export enum OrderExpenseTypeEnum {
    SMS_SENDING = 'sms_sending',
    MARKETPLACE_COMMISSION = 'marketplace_commission',
    PRODUCTS_COST = 'products_cost'
}